import { request } from '@/libs/api-request'

export function myIp (force = true) {
  const url = `/ip_block/my_ip`

  const config = {
    method: 'get',
    url
  }

  return request(config, force)
}

export function getIpList (sid, force = true) {
  const url = '/ba/ip_block/get_ip_list_by_sid'

  const config = {
    method: 'post',
    url,
    data: { sid }
  }

  return request(config, force)
}

export function insertIp (param, force = true) {
  const url = `/ba/ip_block/insert_ip`

  const config = {
    method: 'post',
    url,
    data: param
  }

  return request(config, force)
}

export function removeIp (id, force = true) {
  const url = `/ba/ip_block/remove_ip`

  const config = {
    method: 'post',
    url,
    data: id
  }

  return request(config, force)
}

export function updateIp (param, force = true) {
  const url = `/ba/ip_block/update_ip`

  const config = {
    method: 'post',
    url,
    data: param
  }

  return request(config, force)
}
